module.exports = __webpack_public_path__ + "media/images/logo-shape-news-03ec2dcddeddfdc6c149612794a0582c.svg";